import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import Modal from 'components/Modal';
import * as actions from '../../actions';
import { AVATAR_CROP_MODAL } from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import { getCroppedImg } from './helpers';
import AvatarCrop from './AvatarCrop';
import ImageInput from './ImageInput';
import styles from './AvatarCropModal.pcss';
const AvatarCropModal = ({ adjustHeaderMessage, uploadHeaderMessage, isRound = false, onImageSubmit })=>{
    useStyles(styles);
    const openModalId = useSelector(selectors.modal);
    const closeModal = useAction(actions.closeModal);
    const [imageSrc, setImageSrc] = useState(null);
    const [rotation, setRotation] = useState(0);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const onClose = ()=>{
        closeModal();
        setImageSrc(null);
    };
    const onSubmit = async ()=>{
        try {
            const croppedImg = await getCroppedImg(imageSrc, croppedAreaPixels, rotation);
            onImageSubmit(croppedImg);
            onClose();
        } catch (e) {
            console.error(e);
        }
    };
    return /*#__PURE__*/ _jsxs(Modal, {
        modalId: AVATAR_CROP_MODAL,
        openModalId: openModalId,
        headerMessage: imageSrc ? adjustHeaderMessage : uploadHeaderMessage,
        onClose: onClose,
        children: [
            imageSrc ? /*#__PURE__*/ _jsx(AvatarCrop, {
                imageSrc: imageSrc,
                rotation: rotation,
                isRound: isRound,
                setCroppedAreaPixels: setCroppedAreaPixels,
                setRotation: setRotation
            }) : /*#__PURE__*/ _jsx(ImageInput, {
                isRound: isRound,
                setImageSrc: setImageSrc
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: `col-${imageSrc ? 6 : 12}`,
                        children: /*#__PURE__*/ _jsx(Button, {
                            styleModifier: "primary",
                            labelMessage: messages.buttons[imageSrc ? 'cancel' : 'close'],
                            className: "btn--block",
                            onClick: onClose
                        })
                    }),
                    imageSrc && /*#__PURE__*/ _jsx("div", {
                        className: "col-6",
                        children: /*#__PURE__*/ _jsx(Button, {
                            styleModifier: "primary",
                            labelMessage: messages.buttons.accept,
                            className: "btn--block btn--filled",
                            onClick: onSubmit
                        })
                    })
                ]
            })
        ]
    });
};
export default AvatarCropModal;
